import React, { useEffect } from "react";
import axios from "axios";
import { useAuth } from "../AuthContext";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = () => {
      axios
        .post(`${process.env.REACT_APP_API_URL}/logout`)
        .then((response) => {
          if (response.data.success) {
            logout(); // Make sure to call logout to update your auth state
            navigate("/login");
          } else {
            alert("Logout failed. Please try again.");
          }
        })
        .catch((error) => {
          console.error("Logout error:", error);
          alert("Logout failed. Please try again.");
        });
    };

    handleLogout();
  }, [logout, navigate]); // Adding dependencies to the useEffect hook

  // Optionally, render null or a loading indicator while the logout process is ongoing
  return null; // Or <div>Logging out...</div>
};

export default Logout;
